export default __webpack_public_path__ + "static/media/logo.c64649f7.png";